import {Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import { HttpClient} from '@angular/common/http';
import {environment as env} from '../../../environments/environment';
import {LanguageService} from '../../services/language.service';
import { DatePipe } from '@angular/common';
import { empty } from 'rxjs';

@Component({
  selector: 'app-myaccount',
  templateUrl: './myaccount.component.html',
  styleUrls: ['./myaccount.component.css']
})
export class MyaccountComponent implements OnInit {
  uname:string;
  sajid:string;
  userdata:[] = [];
  adrsData:[] = [];
  recentOrder:[] = [];
  isEmptyAdr:boolean;
  isrecentOrder:boolean;
  isLoading:boolean;
  showLang:string;
  ordStatus:string;
  ordStatus_ar:string;

  constructor(private router:Router, private route:ActivatedRoute, 
    private http:HttpClient,private langObj:LanguageService) {
      this.langObj.langStr.subscribe((data)=>{
        this.showLang = data; 
      });
    }

  ngOnInit(): void {

    this.showLang = localStorage.getItem("showLang");
    if(this.showLang == null && this.showLang == undefined){
     this.showLang = 'en';
    }

    this.isLoading = true;
    this.uname = localStorage.getItem('sajuname');
    this.sajid = localStorage.getItem('sajid');

    this.http.get(env.apiurl+'get-user-by-id/'+this.sajid).subscribe(data=>{
      this.userdata = data['data'];
    });


    this.http.get(env.apiurl+'get-first-address-by-uid/'+this.sajid).subscribe(data=>{
      if(data['data']){
        this.isEmptyAdr = true;
      }
      this.adrsData = data['data'];
    });


    //get recent order
    this.http.post(env.apiurl+'get-recentorder', {
      userid:this.sajid
      }).subscribe(rawData=>{
        this.isLoading = false;
        this.recentOrder = rawData['data'];
        this.ordStatus = rawData['data']['order_status'];
        this.ordStatus_ar = rawData['data']['order_status_ar'];
        if(this.ordStatus == '5'){
          this.ordStatus = "Canceled";
        }else{
          this.ordStatus_ar = "ألغيت";
        }

        if(rawData['data']){this.isrecentOrder = true;}
      });
    }

    logout(){
      localStorage.removeItem('sajid');
      localStorage.removeItem('sajuname');
      localStorage.removeItem('sajtoken');
      this.router.navigate(['order-online']); 
    }

}
